var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.25V12.5345L13.2446 12.6798L16.3145 14.5042L16.1057 14.8551L12.5 12.7153V8.5H13V12.25ZM4 12.5H4.5V12C4.5 9.74566 5.39553 7.58365 6.98959 5.98959C8.58365 4.39553 10.7457 3.5 13 3.5C15.2543 3.5 17.4163 4.39553 19.0104 5.98959C20.6045 7.58365 21.5 9.74566 21.5 12C21.5 14.2543 20.6045 16.4163 19.0104 18.0104C17.4163 19.6045 15.2543 20.5 13 20.5L12.9981 20.5C11.8822 20.5042 10.7767 20.286 9.74602 19.8582C8.86877 19.4941 8.06076 18.9843 7.35566 18.3514L8.07049 17.6366C9.38396 18.7942 11.1116 19.5 13 19.5C14.9891 19.5 16.8968 18.7098 18.3033 17.3033C19.7098 15.8968 20.5 13.9891 20.5 12C20.5 10.0109 19.7098 8.10322 18.3033 6.6967C16.8968 5.29018 14.9891 4.5 13 4.5C11.0109 4.5 9.10322 5.29018 7.6967 6.6967C6.29018 8.10322 5.5 10.0109 5.5 12V12.5H6H7.79077L4.96355 15.3202L2.19231 12.5H4Z",
    fill: "#A0A7B2",
    stroke: "#A0A7B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.bbf9ee71d7dc2c216b0523d887c10e6a.svg";
export { ForwardRef as ReactComponent };